"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("border:", theme.spacing[3], " solid ", theme.color.monochrome.medium, ";background-color:", theme.color.monochrome.white, ";border-radius:", theme.spacing[7], ";display:flex;flex-direction:column;font-size:", theme.fontSize.x2large, ";height:", (0, _util.rem)(614), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var statusBar = /*#__PURE__*/(0, _react.css)("height:", (0, _util.rem)(18), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:statusBar;"));

var header = function header(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;&>svg:first-of-type{transform:rotate(90deg);width:", theme.spacing[11], ";height:", theme.spacing[11], ";color:", theme.color.facebookMessenger.highlight, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:header;"));
};

var companyInfo = function companyInfo(theme) {
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.semibold, ";display:flex;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:companyInfo;"));
};

var main = function main(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-grow:1;overflow-y:auto;padding-left:", theme.spacing[10], ";&>*{margin-bottom:", theme.spacing[6], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
};

var options = function options(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.facebookMessenger.highlight, ";color:", theme.color.monochrome.white, ";width:", theme.spacing[18], ";height:", theme.spacing[14], ";border-radius:", theme.spacing[10], ";display:flex;align-items:center;justify-content:center;margin-left:auto;svg:first-of-type{width:", theme.spacing[10], ";height:", theme.spacing[10], ";}svg:nth-of-type(2){width:", (0, _util.rem)(7), ";height:", (0, _util.rem)(7), ";transform:rotate(180deg);margin-left:", theme.spacing[2], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:options;"));
};

var footer = function footer(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-shrink:0;flex-basis:", (0, _util.rem)(42), ";display:flex;align-items:center;margin:", theme.spacing[5], ";color:", theme.color.externalBrand.facebookMessenger, ";svg{flex-shrink:0;}&>svg{width:", (0, _util.rem)(40), ";height:", (0, _util.rem)(40), ";margin:0 ", theme.spacing[2], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"));
};

var inputWrapper = function inputWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.facebookMessenger.commentBackground, ";flex-grow:1;height:", (0, _util.rem)(34), ";border-radius:", theme.spacing[11], ";display:flex;align-items:center;justify-content:space-between;margin-left:", theme.spacing[14], ";input{border:none;background-color:transparent;width:100%;height:100%;padding-left:", theme.spacing[6], ";:focus{outline:none;}}svg{width:", (0, _util.rem)(40), ";height:", (0, _util.rem)(40), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:inputWrapper;"));
};

var like = function like(theme) {
  return /*#__PURE__*/(0, _react.css)("svg{width:", theme.spacing[12], ";height:", theme.spacing[12], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:like;"));
};

var styles = {
  base: base,
  statusBar: statusBar,
  main: main,
  header: header,
  companyInfo: companyInfo,
  options: options,
  footer: footer,
  inputWrapper: inputWrapper,
  like: like
};
exports.styles = styles;
//# sourceMappingURL=FacebookMessenger.styles.js.map